// 后端现有VIP汇总按 rebateRules.rate 读取默认比例，不推断未返回的分类比例。
export function vipDefaultRebateRate(value) {
  try {
    const rules=typeof value==='string'?JSON.parse(value):value
    const rate=rules && !Array.isArray(rules) ? rules.rate : null
    return rate != null && /^\d+(?:\.\d+)?$/.test(String(rate)) ? String(rate) : null
  } catch { return null }
}

// 门槛只做字符串分组，保留非零小数，避免大金额经 Number 损失精度。
export function formatVipThreshold(value) {
  const match=/^(\d+)(?:\.(\d+))?$/.exec(String(value ?? '').trim())
  if(!match)return '—'
  const fraction=(match[2] || '').replace(/0+$/,'')
  return match[1].replace(/\B(?=(\d{3})+(?!\d))/g,',')+(fraction?`.${fraction}`:'')
}

// 与后台等级返水配置同源；逐游戏配置显示范围，零比例保留，空配置不使用旧等级比例。
export function vipRebateRateText(value) {
  let rules = value;
  try { if (typeof rules === 'string') rules = JSON.parse(rules); } catch { return '未配置'; }
  if (!rules || Array.isArray(rules) || typeof rules !== 'object') return '未配置';
  const rawRates = Array.isArray(rules.venues)
    ? rules.venues.flatMap((venue) => Array.isArray(venue.games) ? venue.games.map((game) => game.rate) : [])
    : [rules.rate];
  if (!rawRates.length || rawRates.some((rate) => !['number', 'string'].includes(typeof rate)
    || !/^\d+(?:\.\d+)?$/.test(String(rate)) || Number(rate) > 100)) return '未配置';
  const rates = rawRates.map(Number);
  const format = (rate) => `${rate.toFixed(4).replace(/(\.\d{2})0+$/, '$1').replace(/(\.\d{3})0$/, '$1')}%`;
  const minimum = rates.reduce((value, rate) => Math.min(value, rate), rates[0]);
  const maximum = rates.reduce((value, rate) => Math.max(value, rate), rates[0]);
  return minimum === maximum ? format(minimum) : `${format(minimum)} ～ ${format(maximum)}`;
}

// 只展示明确配置；空规则兼容旧任务，不能推导个人资格、发放结果或默认时间。
export function readVipWeeklyDisplay(value) {
  const unknown = { time: '—', turnover: '—', validity: '—' };
  if (value == null || value === '' || value === 'null') return unknown;
  let rule = value;
  try { if (typeof rule === 'string') rule = JSON.parse(rule); } catch (_) { return unknown; }
  if (!rule || Array.isArray(rule) || typeof rule !== 'object') return unknown;
  if (rule.enabled === false) return { ...unknown, time: '已停用' };
  if (rule.enabled !== true) return unknown;
  const time = /^每周[一二三四五六日天]$/.test(rule.grantTime || '') ? `${rule.grantTime}（北京时间）` : '—';
  const turnover = ['string', 'number'].includes(typeof rule.turnoverRequirement) && /^\d+(?:\.\d+)?$/.test(String(rule.turnoverRequirement))
    ? String(rule.turnoverRequirement) : '—';
  const valid = Number.isSafeInteger(rule.validValue) && rule.validValue > 0;
  const validity = rule.validType === 9 ? '永久' : valid && [1, 2].includes(rule.validType)
    ? `${rule.validValue}${rule.validType === 1 ? '天' : '小时'}` : '—';
  return { time, turnover, validity };
}
